import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";

import { URL_LOGIN } from "Helpers/Paths";

function ProtectedRoute(props) {
	const { children } = props;
	const isLoggedIn = useSelector((state) => state.Auth.isLoggedIn);

	if (!isLoggedIn) {
		// Teachers/schools enter the CMS from the Website portal (login?token=...).
		// If this tab's session ends, send them back to THAT portal's login page,
		// never the admin login. The marker is per-tab (sessionStorage), so an admin
		// session in another tab is unaffected.
		if (sessionStorage.getItem("cms_loginPortal") === "teacher") {
			window.location.replace(`${process.env.REACT_APP_WEBSITE_URL}teacher/login`);
			return null;
		}
		return <Redirect to={URL_LOGIN} />;
	}

	return (
		<div>
			<Fragment>{children}</Fragment>
		</div>
	);
}

export default ProtectedRoute;
